import { useQuery } from '@tanstack/react-query';
import bookingAcceptedConsentsApi from '@/features/dashboard/bookings/api/bookingAcceptedConsentsApi.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';

export const useGetMissingRequiredConsents = (bookingId: string) =>
  useQuery({
    queryKey: bookingsApiQueryKeys.missingRequiredConsents(bookingId),
    queryFn: () => bookingAcceptedConsentsApi.getMissingRequired(bookingId),
  });
